/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { HttpException } from './HttpException';

/**
 * HTTP error for 302 redirects
 */
export class HttpRedirectException extends HttpException {
    public static Name: string = 'HttpRedirectException';
    public location: string;

    constructor(location: string) {
        super(302);
        this.location = location;
        this.name = HttpRedirectException.Name;
        // As of Typescript 2.1 if we extend the Error object the prototype must be set explicitly
        // See: https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, HttpRedirectException.prototype);
    }
}
